import React from 'react';

import './PriceWithSpecialPrice.scss';

interface Props {
    price: string;
    specialPrice: string | null;
}

const PriceWithSpecialPrice: React.FunctionComponent<Props> = (props) => {
    if (props.specialPrice) {
        return (
            <span className="price-with-special-price">
                {props.specialPrice}
                <s>{props.price}</s>
            </span>
        );
    }

    return <>{props.price}</>;
};

export default PriceWithSpecialPrice;
